const en = {
  menuNotFound: "Menu not found",
  menuNotFoundDesc: "This QR code doesn't link to an active restaurant.",
  orderPlaced: "Order placed!",
  tableTrack: "Table {table} · track your food live below.",
  savedHistory: "Saved to your order history",
  trackCopied: "Tracking link copied",
  saveTrackLink: "Save my tracking link",
  orderMore: "Order more",
  myAccount: "My account",
  logIn: "Log in",
  closedBanner: "We're closed right now, so ordering is paused. Feel free to browse the menu.",
  table: "Table {n}",
  collectStamps: "Collect stamps → {reward}",
  yourAccount: "Your account",
  loginPrompt: "Log in to keep your order history and stamps in one place.",
  welcome: "Welcome!",
  welcomeName: "Welcome, {name}!",
  searchDishes: "Search dishes...",
  all: "All",
  noDishes: "No dishes here yet.",
  soldOut: "Sold out",
  add: "Add",
  added: "{name} added",
  itemOne: "{n} item",
  itemMany: "{n} items",
  viewCart: "View cart",
  yourOrder: "Your order",
  notePlaceholder: "Any note for the kitchen? (allergies, no onions...)",
  totalCounter: "Total · pay at counter",
  placeOrder: "Place order",
  closedNow: "Sorry, we're closed right now.",
  weOpen: "We open {day} at {time}.",
  soldOutMsg: "Sorry, now sold out: {names}",
  orderError: "Could not place order. Please try again.",
  stepPending: "Order received",
  stepPendingDesc: "The kitchen has your order",
  stepPreparing: "Preparing",
  stepPreparingDesc: "Your food is being cooked",
  stepReady: "Ready",
  stepReadyDesc: "Come grab it — it's all set!",
  stepDelivered: "Served",
  stepDeliveredDesc: "Enjoy your meal!",
  statusCancelled: "Cancelled",
  orderNotFound: "Order not found",
  orderNotFoundDesc: "This tracking link is invalid or the order was removed.",
  orderLabel: "Order #{id} · Table {table}",
  cancelledTitle: "Sorry, your order was cancelled",
  reason: "Reason: {r}",
  askStaff: "Please ask our staff if you have any questions.",
  readyTitle: "Your order is ready!",
  readyDesc: "Please collect it from the counter.",
  totalNotCharged: "Total · not charged",
  totalPay: "Total · pay at counter or Scan QR to Pay",
  scanToPay: "Scan to pay",
  scanToPayWith: "Scan to pay with {m}",
  amount: "Amount:",
  showPayment: "show your payment to staff",
  liveStatus: "Live order status",
  autoUpdate: "This page updates automatically. Bookmark it to check back anytime.",
  getDirections: "Get directions",
  openNow: "Open now",
  until: "until {t}",
  closed: "Closed",
  opens: "opens {day} at {time}",
  today: "today",
  tomorrow: "tomorrow",
  Monday: "Monday",
  Tuesday: "Tuesday",
  Wednesday: "Wednesday",
  Thursday: "Thursday",
  Friday: "Friday",
  Saturday: "Saturday",
  Sunday: "Sunday",
  loyaltyRewards: "Loyalty Rewards",
  stampsCount: "{n} / {r} stamps",
  rewardLabel: "Reward:",
  freeItem: "A free item!",
  scanPullCard: "Scan to pull up this card",
  scanPullDesc: "Show this to staff — they can scan it to find your card and add a stamp instantly.",
  rewardUnlocked: "Reward unlocked!",
  showCode: "Show this code at the counter",
  rewardsAvailable: "({n} rewards available)",
  stampCard: "Stamp Card",
  enterPhoneStart: "Enter your phone number to start collecting stamps. Earn {reward} after {n} stamps.",
  phone: "Phone number",
  nameOptional: "Name (optional)",
  yourName: "Your name",
  viewMyCard: "View my card",
  askStaffStamp: "Ask a staff member to add a stamp with each purchase.",
  saveCardLink: "Save my card link",
  cardLinkCopied: "Card link copied — keep it to track your stamps!",
  loyaltyStampCard: "Loyalty stamp card",
  hiCard: "Hi {name}, here's your card:",
  bookmarkStamps: "Bookmark this page to track your stamps anytime.",
  useDifferent: "Use a different number",
  signUp: "Sign up",
  viewStamps: "View my stamps",
  joinRewards: "Join {name} rewards.",
  joinEarn: "Join {name} rewards — earn {reward} after {n} stamps.",
  signUpView: "Sign up & view card",
  enterPhoneView: "Enter your phone number to view your stamp card.",
  cardNotFound: "Card not found",
  restaurant: "Restaurant",
  createAccount: "Create account",
  password: "Password",
  passwordPh: "At least 4 characters",
  forgot: "Forgot your password? Ask our staff to reset it.",
  backToMenu: "Back to menu",
  hi: "Hi",
  logOut: "Log out",
  loggedOut: "Logged out",
  loginToSee: "Log in to see your order history and stamps.",
  orderHistory: "Order history",
  noOrders: "No orders yet. Orders you place while logged in show up here.",
  rewardsHistory: "Rewards history",
  noRewards: "No rewards yet. Keep collecting stamps!",
  rewardEarned: "Reward earned",
  rewardRedeemed: "Reward redeemed",
  language: "Language",
  loyaltyOff: "The stamp card program isn't available at this restaurant right now.",
  emailReceipt: "Email me a receipt",
  send: "Send",
  receiptSent: "Receipt sent to {email}",
  receiptAgain: "Send again",
  receiptError: "Couldn't send the receipt. Please try again.",
  receiptInvalid: "Please enter a valid email address.",
  receiptUnavailable: "Email receipts aren't available right now. Please ask our staff for a receipt.",
};

const ms = {
  menuNotFound: "Menu tidak dijumpai",
  menuNotFoundDesc: "Kod QR ini tidak dipautkan ke restoran yang aktif.",
  orderPlaced: "Pesanan dihantar!",
  tableTrack: "Meja {table} · jejak makanan anda secara langsung di bawah.",
  savedHistory: "Disimpan dalam sejarah pesanan anda",
  trackCopied: "Pautan jejak disalin",
  saveTrackLink: "Simpan pautan jejak saya",
  orderMore: "Pesan lagi",
  myAccount: "Akaun saya",
  logIn: "Log masuk",
  closedBanner: "Kami tutup sekarang, jadi pesanan dihentikan seketika. Anda masih boleh melihat menu.",
  table: "Meja {n}",
  collectStamps: "Kumpul setem → {reward}",
  yourAccount: "Akaun anda",
  loginPrompt: "Log masuk untuk menyimpan sejarah pesanan dan setem anda di satu tempat.",
  welcome: "Selamat datang!",
  welcomeName: "Selamat datang, {name}!",
  searchDishes: "Cari hidangan...",
  all: "Semua",
  noDishes: "Belum ada hidangan di sini.",
  soldOut: "Habis dijual",
  add: "Tambah",
  added: "{name} ditambah",
  itemOne: "{n} item",
  itemMany: "{n} item",
  viewCart: "Lihat troli",
  yourOrder: "Pesanan anda",
  notePlaceholder: "Ada nota untuk dapur? (alahan, tanpa bawang...)",
  totalCounter: "Jumlah · bayar di kaunter",
  placeOrder: "Hantar pesanan",
  closedNow: "Maaf, kami tutup sekarang.",
  weOpen: "Kami buka {day} pada {time}.",
  soldOutMsg: "Maaf, sudah habis: {names}",
  orderError: "Pesanan tidak dapat dihantar. Sila cuba lagi.",
  stepPending: "Pesanan diterima",
  stepPendingDesc: "Dapur telah menerima pesanan anda",
  stepPreparing: "Sedang disediakan",
  stepPreparingDesc: "Makanan anda sedang dimasak",
  stepReady: "Siap",
  stepReadyDesc: "Sila ambil — semuanya sudah siap!",
  stepDelivered: "Dihidangkan",
  stepDeliveredDesc: "Selamat menjamu selera!",
  statusCancelled: "Dibatalkan",
  orderNotFound: "Pesanan tidak dijumpai",
  orderNotFoundDesc: "Pautan jejak ini tidak sah atau pesanan telah dipadam.",
  orderLabel: "Pesanan #{id} · Meja {table}",
  cancelledTitle: "Maaf, pesanan anda telah dibatalkan",
  reason: "Sebab: {r}",
  askStaff: "Sila tanya kakitangan kami jika ada sebarang soalan.",
  readyTitle: "Pesanan anda sudah siap!",
  readyDesc: "Sila ambil di kaunter.",
  totalNotCharged: "Jumlah · tidak dicaj",
  totalPay: "Jumlah · bayar di kaunter atau Imbas QR untuk Bayar",
  scanToPay: "Imbas untuk bayar",
  scanToPayWith: "Imbas untuk bayar dengan {m}",
  amount: "Amaun:",
  showPayment: "tunjukkan bukti bayaran kepada kakitangan",
  liveStatus: "Status pesanan langsung",
  autoUpdate: "Halaman ini dikemas kini secara automatik. Tandakan halaman ini untuk semak semula bila-bila masa.",
  getDirections: "Dapatkan arah",
  openNow: "Dibuka sekarang",
  until: "hingga {t}",
  closed: "Tutup",
  opens: "dibuka {day} pada {time}",
  today: "hari ini",
  tomorrow: "esok",
  Monday: "Isnin",
  Tuesday: "Selasa",
  Wednesday: "Rabu",
  Thursday: "Khamis",
  Friday: "Jumaat",
  Saturday: "Sabtu",
  Sunday: "Ahad",
  loyaltyRewards: "Ganjaran Kesetiaan",
  stampsCount: "{n} / {r} setem",
  rewardLabel: "Ganjaran:",
  freeItem: "Satu item percuma!",
  scanPullCard: "Imbas untuk buka kad ini",
  scanPullDesc: "Tunjukkan kepada kakitangan — mereka boleh mengimbasnya untuk mencari kad anda dan menambah setem serta-merta.",
  rewardUnlocked: "Ganjaran dibuka!",
  showCode: "Tunjukkan kod ini di kaunter",
  rewardsAvailable: "({n} ganjaran tersedia)",
  stampCard: "Kad Setem",
  enterPhoneStart: "Masukkan nombor telefon anda untuk mula mengumpul setem. Dapatkan {reward} selepas {n} setem.",
  phone: "Nombor telefon",
  nameOptional: "Nama (pilihan)",
  yourName: "Nama anda",
  viewMyCard: "Lihat kad saya",
  askStaffStamp: "Minta kakitangan menambah setem setiap kali anda membeli.",
  saveCardLink: "Simpan pautan kad saya",
  cardLinkCopied: "Pautan kad disalin — simpan untuk menjejak setem anda!",
  loyaltyStampCard: "Kad setem kesetiaan",
  hiCard: "Hai {name}, ini kad anda:",
  bookmarkStamps: "Tandakan halaman ini untuk menjejak setem anda bila-bila masa.",
  useDifferent: "Guna nombor lain",
  signUp: "Daftar",
  viewStamps: "Lihat setem saya",
  joinRewards: "Sertai ganjaran {name}.",
  joinEarn: "Sertai ganjaran {name} — dapatkan {reward} selepas {n} setem.",
  signUpView: "Daftar & lihat kad",
  enterPhoneView: "Masukkan nombor telefon anda untuk melihat kad setem anda.",
  cardNotFound: "Kad tidak dijumpai",
  restaurant: "Restoran",
  createAccount: "Cipta akaun",
  password: "Kata laluan",
  passwordPh: "Sekurang-kurangnya 4 aksara",
  forgot: "Lupa kata laluan? Minta kakitangan kami menetapkannya semula.",
  backToMenu: "Kembali ke menu",
  hi: "Hai",
  logOut: "Log keluar",
  loggedOut: "Telah log keluar",
  loginToSee: "Log masuk untuk melihat sejarah pesanan dan setem anda.",
  orderHistory: "Sejarah pesanan",
  noOrders: "Belum ada pesanan. Pesanan yang dibuat semasa log masuk akan dipaparkan di sini.",
  rewardsHistory: "Sejarah ganjaran",
  noRewards: "Belum ada ganjaran. Teruskan mengumpul setem!",
  rewardEarned: "Ganjaran diperoleh",
  rewardRedeemed: "Ganjaran ditebus",
  language: "Bahasa",
  loyaltyOff: "Program kad setem tidak tersedia di restoran ini buat masa ini.",
  emailReceipt: "E-melkan resit kepada saya",
  send: "Hantar",
  receiptSent: "Resit dihantar ke {email}",
  receiptAgain: "Hantar lagi",
  receiptError: "Resit tidak dapat dihantar. Sila cuba lagi.",
  receiptInvalid: "Sila masukkan alamat e-mel yang sah.",
  receiptUnavailable: "Resit e-mel tidak tersedia buat masa ini. Sila minta resit daripada kakitangan kami.",
};

const zh = {
  menuNotFound: "未找到菜单",
  menuNotFoundDesc: "此二维码未关联任何营业中的餐厅。",
  orderPlaced: "下单成功！",
  tableTrack: "{table} 号桌 · 在下方实时查看您的餐点进度。",
  savedHistory: "已保存到您的订单记录",
  trackCopied: "追踪链接已复制",
  saveTrackLink: "保存我的追踪链接",
  orderMore: "继续点餐",
  myAccount: "我的账户",
  logIn: "登录",
  closedBanner: "本店目前已打烊，暂停接单。您仍可浏览菜单。",
  table: "{n} 号桌",
  collectStamps: "集印章 → {reward}",
  yourAccount: "您的账户",
  loginPrompt: "登录后可统一保存您的订单记录和印章。",
  welcome: "欢迎！",
  welcomeName: "欢迎，{name}！",
  searchDishes: "搜索菜品...",
  all: "全部",
  noDishes: "这里还没有菜品。",
  soldOut: "已售罄",
  add: "添加",
  added: "已添加 {name}",
  itemOne: "{n} 件",
  itemMany: "{n} 件",
  viewCart: "查看购物车",
  yourOrder: "您的订单",
  notePlaceholder: "给厨房的备注？（过敏、不要洋葱…）",
  totalCounter: "合计 · 柜台付款",
  placeOrder: "提交订单",
  closedNow: "抱歉，本店目前已打烊。",
  weOpen: "我们将于{day} {time} 营业。",
  soldOutMsg: "抱歉，以下菜品已售罄：{names}",
  orderError: "下单失败，请重试。",
  stepPending: "已接单",
  stepPendingDesc: "厨房已收到您的订单",
  stepPreparing: "制作中",
  stepPreparingDesc: "您的餐点正在烹制",
  stepReady: "已备好",
  stepReadyDesc: "餐点已备好，请来取餐！",
  stepDelivered: "已上菜",
  stepDeliveredDesc: "祝您用餐愉快！",
  statusCancelled: "已取消",
  orderNotFound: "未找到订单",
  orderNotFoundDesc: "此追踪链接无效或订单已被删除。",
  orderLabel: "订单 #{id} · {table} 号桌",
  cancelledTitle: "抱歉，您的订单已被取消",
  reason: "原因：{r}",
  askStaff: "如有任何疑问，请咨询我们的店员。",
  readyTitle: "您的餐点已备好！",
  readyDesc: "请到柜台取餐。",
  totalNotCharged: "合计 · 不收费",
  totalPay: "合计 · 柜台付款或扫码支付",
  scanToPay: "扫码支付",
  scanToPayWith: "使用 {m} 扫码支付",
  amount: "金额：",
  showPayment: "请向店员出示付款记录",
  liveStatus: "实时订单状态",
  autoUpdate: "此页面会自动更新。收藏此页面可随时查看。",
  getDirections: "导航",
  openNow: "营业中",
  until: "至 {t}",
  closed: "已打烊",
  opens: "{day} {time} 营业",
  today: "今天",
  tomorrow: "明天",
  Monday: "星期一",
  Tuesday: "星期二",
  Wednesday: "星期三",
  Thursday: "星期四",
  Friday: "星期五",
  Saturday: "星期六",
  Sunday: "星期日",
  loyaltyRewards: "会员奖励",
  stampsCount: "{n} / {r} 个印章",
  rewardLabel: "奖励：",
  freeItem: "免费一份！",
  scanPullCard: "扫码打开此卡",
  scanPullDesc: "向店员出示 — 店员扫码即可找到您的卡并立即盖章。",
  rewardUnlocked: "奖励已解锁！",
  showCode: "请在柜台出示此代码",
  rewardsAvailable: "（可用奖励 {n} 个）",
  stampCard: "集章卡",
  enterPhoneStart: "输入手机号码即可开始集章。集满 {n} 个印章可获得 {reward}。",
  phone: "手机号码",
  nameOptional: "姓名（选填）",
  yourName: "您的姓名",
  viewMyCard: "查看我的卡",
  askStaffStamp: "每次消费时请让店员为您盖章。",
  saveCardLink: "保存我的卡链接",
  cardLinkCopied: "卡链接已复制 — 保存它以随时查看印章！",
  loyaltyStampCard: "会员集章卡",
  hiCard: "{name}，您好，这是您的卡：",
  bookmarkStamps: "收藏此页面可随时查看您的印章。",
  useDifferent: "使用其他号码",
  signUp: "注册",
  viewStamps: "查看我的印章",
  joinRewards: "加入 {name} 会员奖励。",
  joinEarn: "加入 {name} 会员奖励 — 集满 {n} 个印章可获得 {reward}。",
  signUpView: "注册并查看卡",
  enterPhoneView: "输入手机号码查看您的集章卡。",
  cardNotFound: "未找到此卡",
  restaurant: "餐厅",
  createAccount: "创建账户",
  password: "密码",
  passwordPh: "至少 4 个字符",
  forgot: "忘记密码？请联系店员为您重置。",
  backToMenu: "返回菜单",
  hi: "您好",
  logOut: "退出登录",
  loggedOut: "已退出登录",
  loginToSee: "登录后查看您的订单记录和印章。",
  orderHistory: "订单记录",
  noOrders: "暂无订单。登录后下的订单会显示在这里。",
  rewardsHistory: "奖励记录",
  noRewards: "暂无奖励。继续集章吧！",
  rewardEarned: "获得奖励",
  rewardRedeemed: "已兑换奖励",
  language: "语言",
  loyaltyOff: "本餐厅目前未开放集章卡活动。",
  emailReceipt: "通过电子邮件发送收据",
  send: "发送",
  receiptSent: "收据已发送至 {email}",
  receiptAgain: "再次发送",
  receiptError: "收据发送失败，请重试。",
  receiptInvalid: "请输入有效的电子邮箱地址。",
  receiptUnavailable: "目前无法发送电子收据，请向店员索取收据。",
};

const id = {
  menuNotFound: "Menu tidak ditemukan",
  menuNotFoundDesc: "Kode QR ini tidak terhubung ke restoran yang aktif.",
  orderPlaced: "Pesanan terkirim!",
  tableTrack: "Meja {table} · pantau makanan Anda secara langsung di bawah.",
  savedHistory: "Disimpan ke riwayat pesanan Anda",
  trackCopied: "Tautan pelacakan disalin",
  saveTrackLink: "Simpan tautan pelacakan saya",
  orderMore: "Pesan lagi",
  myAccount: "Akun saya",
  logIn: "Masuk",
  closedBanner: "Kami sedang tutup, jadi pemesanan dihentikan sementara. Silakan lihat menu.",
  table: "Meja {n}",
  collectStamps: "Kumpulkan stempel → {reward}",
  yourAccount: "Akun Anda",
  loginPrompt: "Masuk untuk menyimpan riwayat pesanan dan stempel Anda di satu tempat.",
  welcome: "Selamat datang!",
  welcomeName: "Selamat datang, {name}!",
  searchDishes: "Cari hidangan...",
  all: "Semua",
  noDishes: "Belum ada hidangan di sini.",
  soldOut: "Habis",
  add: "Tambah",
  added: "{name} ditambahkan",
  itemOne: "{n} item",
  itemMany: "{n} item",
  viewCart: "Lihat keranjang",
  yourOrder: "Pesanan Anda",
  notePlaceholder: "Ada catatan untuk dapur? (alergi, tanpa bawang...)",
  totalCounter: "Total · bayar di kasir",
  placeOrder: "Kirim pesanan",
  closedNow: "Maaf, kami sedang tutup.",
  weOpen: "Kami buka {day} pukul {time}.",
  soldOutMsg: "Maaf, sudah habis: {names}",
  orderError: "Pesanan gagal dikirim. Silakan coba lagi.",
  stepPending: "Pesanan diterima",
  stepPendingDesc: "Dapur sudah menerima pesanan Anda",
  stepPreparing: "Sedang disiapkan",
  stepPreparingDesc: "Makanan Anda sedang dimasak",
  stepReady: "Siap",
  stepReadyDesc: "Silakan ambil — semuanya sudah siap!",
  stepDelivered: "Disajikan",
  stepDeliveredDesc: "Selamat menikmati!",
  statusCancelled: "Dibatalkan",
  orderNotFound: "Pesanan tidak ditemukan",
  orderNotFoundDesc: "Tautan pelacakan ini tidak valid atau pesanan telah dihapus.",
  orderLabel: "Pesanan #{id} · Meja {table}",
  cancelledTitle: "Maaf, pesanan Anda dibatalkan",
  reason: "Alasan: {r}",
  askStaff: "Silakan tanyakan kepada staf kami jika ada pertanyaan.",
  readyTitle: "Pesanan Anda sudah siap!",
  readyDesc: "Silakan ambil di kasir.",
  totalNotCharged: "Total · tidak ditagih",
  totalPay: "Total · bayar di kasir atau Pindai QR untuk Bayar",
  scanToPay: "Pindai untuk bayar",
  scanToPayWith: "Pindai untuk bayar dengan {m}",
  amount: "Jumlah:",
  showPayment: "tunjukkan bukti pembayaran ke staf",
  liveStatus: "Status pesanan langsung",
  autoUpdate: "Halaman ini diperbarui otomatis. Simpan halaman ini untuk cek kapan saja.",
  getDirections: "Petunjuk arah",
  openNow: "Buka sekarang",
  until: "sampai {t}",
  closed: "Tutup",
  opens: "buka {day} pukul {time}",
  today: "hari ini",
  tomorrow: "besok",
  Monday: "Senin",
  Tuesday: "Selasa",
  Wednesday: "Rabu",
  Thursday: "Kamis",
  Friday: "Jumat",
  Saturday: "Sabtu",
  Sunday: "Minggu",
  loyaltyRewards: "Hadiah Loyalitas",
  stampsCount: "{n} / {r} stempel",
  rewardLabel: "Hadiah:",
  freeItem: "Satu item gratis!",
  scanPullCard: "Pindai untuk membuka kartu ini",
  scanPullDesc: "Tunjukkan ke staf — mereka bisa memindainya untuk menemukan kartu Anda dan langsung menambah stempel.",
  rewardUnlocked: "Hadiah terbuka!",
  showCode: "Tunjukkan kode ini di kasir",
  rewardsAvailable: "({n} hadiah tersedia)",
  stampCard: "Kartu Stempel",
  enterPhoneStart: "Masukkan nomor telepon Anda untuk mulai mengumpulkan stempel. Dapatkan {reward} setelah {n} stempel.",
  phone: "Nomor telepon",
  nameOptional: "Nama (opsional)",
  yourName: "Nama Anda",
  viewMyCard: "Lihat kartu saya",
  askStaffStamp: "Minta staf menambahkan stempel setiap kali Anda membeli.",
  saveCardLink: "Simpan tautan kartu saya",
  cardLinkCopied: "Tautan kartu disalin — simpan untuk melacak stempel Anda!",
  loyaltyStampCard: "Kartu stempel loyalitas",
  hiCard: "Hai {name}, ini kartu Anda:",
  bookmarkStamps: "Simpan halaman ini untuk melacak stempel Anda kapan saja.",
  useDifferent: "Gunakan nomor lain",
  signUp: "Daftar",
  viewStamps: "Lihat stempel saya",
  joinRewards: "Gabung hadiah {name}.",
  joinEarn: "Gabung hadiah {name} — dapatkan {reward} setelah {n} stempel.",
  signUpView: "Daftar & lihat kartu",
  enterPhoneView: "Masukkan nomor telepon Anda untuk melihat kartu stempel.",
  cardNotFound: "Kartu tidak ditemukan",
  restaurant: "Restoran",
  createAccount: "Buat akun",
  password: "Kata sandi",
  passwordPh: "Minimal 4 karakter",
  forgot: "Lupa kata sandi? Minta staf kami untuk mengaturnya ulang.",
  backToMenu: "Kembali ke menu",
  hi: "Hai",
  logOut: "Keluar",
  loggedOut: "Berhasil keluar",
  loginToSee: "Masuk untuk melihat riwayat pesanan dan stempel Anda.",
  orderHistory: "Riwayat pesanan",
  noOrders: "Belum ada pesanan. Pesanan yang dibuat saat masuk akan muncul di sini.",
  rewardsHistory: "Riwayat hadiah",
  noRewards: "Belum ada hadiah. Terus kumpulkan stempel!",
  rewardEarned: "Hadiah didapat",
  rewardRedeemed: "Hadiah ditukar",
  language: "Bahasa",
  loyaltyOff: "Program kartu stempel belum tersedia di restoran ini saat ini.",
  emailReceipt: "Kirim struk ke email saya",
  send: "Kirim",
  receiptSent: "Struk dikirim ke {email}",
  receiptAgain: "Kirim lagi",
  receiptError: "Struk gagal dikirim. Silakan coba lagi.",
  receiptInvalid: "Masukkan alamat email yang valid.",
  receiptUnavailable: "Struk email belum tersedia saat ini. Silakan minta struk ke staf kami.",
};

const th = {
  menuNotFound: "ไม่พบเมนู",
  menuNotFoundDesc: "คิวอาร์โค้ดนี้ไม่ได้เชื่อมกับร้านอาหารที่เปิดใช้งาน",
  orderPlaced: "สั่งอาหารเรียบร้อย!",
  tableTrack: "โต๊ะ {table} · ติดตามอาหารของคุณแบบเรียลไทม์ด้านล่าง",
  savedHistory: "บันทึกในประวัติการสั่งซื้อแล้ว",
  trackCopied: "คัดลอกลิงก์ติดตามแล้ว",
  saveTrackLink: "บันทึกลิงก์ติดตามของฉัน",
  orderMore: "สั่งเพิ่ม",
  myAccount: "บัญชีของฉัน",
  logIn: "เข้าสู่ระบบ",
  closedBanner: "ขณะนี้ร้านปิดอยู่ จึงหยุดรับออร์เดอร์ชั่วคราว คุณยังดูเมนูได้",
  table: "โต๊ะ {n}",
  collectStamps: "สะสมแสตมป์ → {reward}",
  yourAccount: "บัญชีของคุณ",
  loginPrompt: "เข้าสู่ระบบเพื่อเก็บประวัติการสั่งซื้อและแสตมป์ไว้ในที่เดียว",
  welcome: "ยินดีต้อนรับ!",
  welcomeName: "ยินดีต้อนรับ {name}!",
  searchDishes: "ค้นหาเมนู...",
  all: "ทั้งหมด",
  noDishes: "ยังไม่มีเมนูในหมวดนี้",
  soldOut: "หมดแล้ว",
  add: "เพิ่ม",
  added: "เพิ่ม {name} แล้ว",
  itemOne: "{n} รายการ",
  itemMany: "{n} รายการ",
  viewCart: "ดูตะกร้า",
  yourOrder: "ออร์เดอร์ของคุณ",
  notePlaceholder: "มีหมายเหตุถึงครัวไหม? (แพ้อาหาร, ไม่ใส่หัวหอม...)",
  totalCounter: "รวม · ชำระที่เคาน์เตอร์",
  placeOrder: "ยืนยันการสั่ง",
  closedNow: "ขออภัย ขณะนี้ร้านปิดอยู่",
  weOpen: "ร้านจะเปิด{day} เวลา {time}",
  soldOutMsg: "ขออภัย หมดแล้ว: {names}",
  orderError: "ไม่สามารถสั่งอาหารได้ กรุณาลองอีกครั้ง",
  stepPending: "รับออร์เดอร์แล้ว",
  stepPendingDesc: "ครัวได้รับออร์เดอร์ของคุณแล้ว",
  stepPreparing: "กำลังเตรียม",
  stepPreparingDesc: "อาหารของคุณกำลังปรุง",
  stepReady: "พร้อมแล้ว",
  stepReadyDesc: "มารับได้เลย — พร้อมแล้ว!",
  stepDelivered: "เสิร์ฟแล้ว",
  stepDeliveredDesc: "ขอให้อร่อยกับมื้อนี้!",
  statusCancelled: "ยกเลิกแล้ว",
  orderNotFound: "ไม่พบออร์เดอร์",
  orderNotFoundDesc: "ลิงก์ติดตามนี้ไม่ถูกต้อง หรือออร์เดอร์ถูกลบไปแล้ว",
  orderLabel: "ออร์เดอร์ #{id} · โต๊ะ {table}",
  cancelledTitle: "ขออภัย ออร์เดอร์ของคุณถูกยกเลิก",
  reason: "เหตุผล: {r}",
  askStaff: "หากมีคำถาม กรุณาสอบถามพนักงานของเรา",
  readyTitle: "อาหารของคุณพร้อมแล้ว!",
  readyDesc: "กรุณารับที่เคาน์เตอร์",
  totalNotCharged: "รวม · ไม่มีค่าใช้จ่าย",
  totalPay: "รวม · ชำระที่เคาน์เตอร์ หรือสแกน QR เพื่อชำระ",
  scanToPay: "สแกนเพื่อชำระเงิน",
  scanToPayWith: "สแกนเพื่อชำระด้วย {m}",
  amount: "ยอดเงิน:",
  showPayment: "แสดงหลักฐานการชำระเงินให้พนักงาน",
  liveStatus: "สถานะออร์เดอร์แบบเรียลไทม์",
  autoUpdate: "หน้านี้อัปเดตอัตโนมัติ บุ๊กมาร์กไว้เพื่อกลับมาดูได้ทุกเมื่อ",
  getDirections: "นำทาง",
  openNow: "เปิดอยู่",
  until: "ถึง {t}",
  closed: "ปิด",
  opens: "เปิด{day} เวลา {time}",
  today: "วันนี้",
  tomorrow: "พรุ่งนี้",
  Monday: "วันจันทร์",
  Tuesday: "วันอังคาร",
  Wednesday: "วันพุธ",
  Thursday: "วันพฤหัสบดี",
  Friday: "วันศุกร์",
  Saturday: "วันเสาร์",
  Sunday: "วันอาทิตย์",
  loyaltyRewards: "รางวัลสมาชิก",
  stampsCount: "{n} / {r} แสตมป์",
  rewardLabel: "รางวัล:",
  freeItem: "ฟรี 1 รายการ!",
  scanPullCard: "สแกนเพื่อเปิดบัตรนี้",
  scanPullDesc: "แสดงให้พนักงาน — พนักงานสแกนเพื่อค้นหาบัตรและเพิ่มแสตมป์ได้ทันที",
  rewardUnlocked: "ปลดล็อกรางวัลแล้ว!",
  showCode: "แสดงรหัสนี้ที่เคาน์เตอร์",
  rewardsAvailable: "(มีรางวัล {n} รายการ)",
  stampCard: "บัตรสะสมแสตมป์",
  enterPhoneStart: "กรอกเบอร์โทรศัพท์เพื่อเริ่มสะสมแสตมป์ รับ {reward} เมื่อครบ {n} แสตมป์",
  phone: "เบอร์โทรศัพท์",
  nameOptional: "ชื่อ (ไม่บังคับ)",
  yourName: "ชื่อของคุณ",
  viewMyCard: "ดูบัตรของฉัน",
  askStaffStamp: "ขอให้พนักงานเพิ่มแสตมป์ทุกครั้งที่ซื้อ",
  saveCardLink: "บันทึกลิงก์บัตรของฉัน",
  cardLinkCopied: "คัดลอกลิงก์บัตรแล้ว — เก็บไว้เพื่อติดตามแสตมป์ของคุณ!",
  loyaltyStampCard: "บัตรสะสมแสตมป์สมาชิก",
  hiCard: "สวัสดี {name} นี่คือบัตรของคุณ:",
  bookmarkStamps: "บุ๊กมาร์กหน้านี้เพื่อติดตามแสตมป์ได้ทุกเมื่อ",
  useDifferent: "ใช้เบอร์อื่น",
  signUp: "สมัคร",
  viewStamps: "ดูแสตมป์ของฉัน",
  joinRewards: "สมัครรับรางวัลของ {name}",
  joinEarn: "สมัครรับรางวัลของ {name} — รับ {reward} เมื่อครบ {n} แสตมป์",
  signUpView: "สมัครและดูบัตร",
  enterPhoneView: "กรอกเบอร์โทรศัพท์เพื่อดูบัตรสะสมแสตมป์ของคุณ",
  cardNotFound: "ไม่พบบัตร",
  restaurant: "ร้านอาหาร",
  createAccount: "สร้างบัญชี",
  password: "รหัสผ่าน",
  passwordPh: "อย่างน้อย 4 ตัวอักษร",
  forgot: "ลืมรหัสผ่าน? ขอให้พนักงานของเรารีเซ็ตให้",
  backToMenu: "กลับไปที่เมนู",
  hi: "สวัสดี",
  logOut: "ออกจากระบบ",
  loggedOut: "ออกจากระบบแล้ว",
  loginToSee: "เข้าสู่ระบบเพื่อดูประวัติการสั่งซื้อและแสตมป์ของคุณ",
  orderHistory: "ประวัติการสั่งซื้อ",
  noOrders: "ยังไม่มีออร์เดอร์ ออร์เดอร์ที่สั่งขณะเข้าสู่ระบบจะแสดงที่นี่",
  rewardsHistory: "ประวัติรางวัล",
  noRewards: "ยังไม่มีรางวัล สะสมแสตมป์ต่อไปนะ!",
  rewardEarned: "ได้รับรางวัล",
  rewardRedeemed: "ใช้รางวัลแล้ว",
  language: "ภาษา",
  loyaltyOff: "ขณะนี้ร้านนี้ยังไม่เปิดให้ใช้บัตรสะสมแสตมป์",
  emailReceipt: "ส่งใบเสร็จทางอีเมล",
  send: "ส่ง",
  receiptSent: "ส่งใบเสร็จไปที่ {email} แล้ว",
  receiptAgain: "ส่งอีกครั้ง",
  receiptError: "ส่งใบเสร็จไม่สำเร็จ กรุณาลองอีกครั้ง",
  receiptInvalid: "กรุณากรอกอีเมลที่ถูกต้อง",
  receiptUnavailable: "ขณะนี้ไม่สามารถส่งใบเสร็จทางอีเมลได้ กรุณาขอใบเสร็จจากพนักงาน",
};

const vi = {
  menuNotFound: "Không tìm thấy thực đơn",
  menuNotFoundDesc: "Mã QR này không liên kết với nhà hàng nào đang hoạt động.",
  orderPlaced: "Đã đặt món!",
  tableTrack: "Bàn {table} · theo dõi món ăn trực tiếp bên dưới.",
  savedHistory: "Đã lưu vào lịch sử đơn hàng của bạn",
  trackCopied: "Đã sao chép liên kết theo dõi",
  saveTrackLink: "Lưu liên kết theo dõi",
  orderMore: "Gọi thêm món",
  myAccount: "Tài khoản của tôi",
  logIn: "Đăng nhập",
  closedBanner: "Hiện chúng tôi đang đóng cửa nên tạm ngừng nhận đơn. Bạn vẫn có thể xem thực đơn.",
  table: "Bàn {n}",
  collectStamps: "Tích tem → {reward}",
  yourAccount: "Tài khoản của bạn",
  loginPrompt: "Đăng nhập để lưu lịch sử đơn hàng và tem ở cùng một nơi.",
  welcome: "Chào mừng!",
  welcomeName: "Chào mừng, {name}!",
  searchDishes: "Tìm món...",
  all: "Tất cả",
  noDishes: "Chưa có món nào ở đây.",
  soldOut: "Hết món",
  add: "Thêm",
  added: "Đã thêm {name}",
  itemOne: "{n} món",
  itemMany: "{n} món",
  viewCart: "Xem giỏ hàng",
  yourOrder: "Đơn của bạn",
  notePlaceholder: "Ghi chú cho bếp? (dị ứng, không hành...)",
  totalCounter: "Tổng · thanh toán tại quầy",
  placeOrder: "Đặt món",
  closedNow: "Xin lỗi, hiện chúng tôi đang đóng cửa.",
  weOpen: "Chúng tôi mở cửa {day} lúc {time}.",
  soldOutMsg: "Xin lỗi, đã hết: {names}",
  orderError: "Không thể đặt món. Vui lòng thử lại.",
  stepPending: "Đã nhận đơn",
  stepPendingDesc: "Bếp đã nhận đơn của bạn",
  stepPreparing: "Đang chuẩn bị",
  stepPreparingDesc: "Món ăn của bạn đang được nấu",
  stepReady: "Đã xong",
  stepReadyDesc: "Mời bạn đến lấy — mọi thứ đã sẵn sàng!",
  stepDelivered: "Đã phục vụ",
  stepDeliveredDesc: "Chúc bạn ngon miệng!",
  statusCancelled: "Đã hủy",
  orderNotFound: "Không tìm thấy đơn hàng",
  orderNotFoundDesc: "Liên kết theo dõi không hợp lệ hoặc đơn hàng đã bị xóa.",
  orderLabel: "Đơn #{id} · Bàn {table}",
  cancelledTitle: "Xin lỗi, đơn của bạn đã bị hủy",
  reason: "Lý do: {r}",
  askStaff: "Vui lòng hỏi nhân viên nếu bạn có thắc mắc.",
  readyTitle: "Món của bạn đã xong!",
  readyDesc: "Vui lòng nhận món tại quầy.",
  totalNotCharged: "Tổng · không tính phí",
  totalPay: "Tổng · thanh toán tại quầy hoặc Quét QR để thanh toán",
  scanToPay: "Quét để thanh toán",
  scanToPayWith: "Quét để thanh toán bằng {m}",
  amount: "Số tiền:",
  showPayment: "đưa xác nhận thanh toán cho nhân viên",
  liveStatus: "Trạng thái đơn trực tiếp",
  autoUpdate: "Trang này tự động cập nhật. Đánh dấu trang để xem lại bất cứ lúc nào.",
  getDirections: "Chỉ đường",
  openNow: "Đang mở cửa",
  until: "đến {t}",
  closed: "Đóng cửa",
  opens: "mở cửa {day} lúc {time}",
  today: "hôm nay",
  tomorrow: "ngày mai",
  Monday: "Thứ Hai",
  Tuesday: "Thứ Ba",
  Wednesday: "Thứ Tư",
  Thursday: "Thứ Năm",
  Friday: "Thứ Sáu",
  Saturday: "Thứ Bảy",
  Sunday: "Chủ Nhật",
  loyaltyRewards: "Ưu đãi thành viên",
  stampsCount: "{n} / {r} tem",
  rewardLabel: "Phần thưởng:",
  freeItem: "Một món miễn phí!",
  scanPullCard: "Quét để mở thẻ này",
  scanPullDesc: "Đưa cho nhân viên — họ có thể quét để tìm thẻ và thêm tem ngay.",
  rewardUnlocked: "Đã mở khóa phần thưởng!",
  showCode: "Đưa mã này tại quầy",
  rewardsAvailable: "(có {n} phần thưởng)",
  stampCard: "Thẻ tích tem",
  enterPhoneStart: "Nhập số điện thoại để bắt đầu tích tem. Nhận {reward} sau {n} tem.",
  phone: "Số điện thoại",
  nameOptional: "Tên (không bắt buộc)",
  yourName: "Tên của bạn",
  viewMyCard: "Xem thẻ của tôi",
  askStaffStamp: "Nhờ nhân viên thêm tem mỗi lần bạn mua.",
  saveCardLink: "Lưu liên kết thẻ",
  cardLinkCopied: "Đã sao chép liên kết thẻ — lưu lại để theo dõi tem!",
  loyaltyStampCard: "Thẻ tích tem thành viên",
  hiCard: "Chào {name}, đây là thẻ của bạn:",
  bookmarkStamps: "Đánh dấu trang này để theo dõi tem bất cứ lúc nào.",
  useDifferent: "Dùng số khác",
  signUp: "Đăng ký",
  viewStamps: "Xem tem của tôi",
  joinRewards: "Tham gia chương trình ưu đãi của {name}.",
  joinEarn: "Tham gia chương trình ưu đãi của {name} — nhận {reward} sau {n} tem.",
  signUpView: "Đăng ký & xem thẻ",
  enterPhoneView: "Nhập số điện thoại để xem thẻ tích tem của bạn.",
  cardNotFound: "Không tìm thấy thẻ",
  restaurant: "Nhà hàng",
  createAccount: "Tạo tài khoản",
  password: "Mật khẩu",
  passwordPh: "Ít nhất 4 ký tự",
  forgot: "Quên mật khẩu? Nhờ nhân viên đặt lại giúp bạn.",
  backToMenu: "Quay lại thực đơn",
  hi: "Chào",
  logOut: "Đăng xuất",
  loggedOut: "Đã đăng xuất",
  loginToSee: "Đăng nhập để xem lịch sử đơn hàng và tem của bạn.",
  orderHistory: "Lịch sử đơn hàng",
  noOrders: "Chưa có đơn nào. Đơn đặt khi đã đăng nhập sẽ hiện ở đây.",
  rewardsHistory: "Lịch sử phần thưởng",
  noRewards: "Chưa có phần thưởng. Hãy tiếp tục tích tem!",
  rewardEarned: "Nhận phần thưởng",
  rewardRedeemed: "Đã đổi phần thưởng",
  language: "Ngôn ngữ",
  loyaltyOff: "Chương trình thẻ tích tem hiện chưa có tại nhà hàng này.",
  emailReceipt: "Gửi hóa đơn qua email",
  send: "Gửi",
  receiptSent: "Đã gửi hóa đơn đến {email}",
  receiptAgain: "Gửi lại",
  receiptError: "Không gửi được hóa đơn. Vui lòng thử lại.",
  receiptInvalid: "Vui lòng nhập địa chỉ email hợp lệ.",
  receiptUnavailable: "Hiện chưa thể gửi hóa đơn qua email. Vui lòng xin hóa đơn từ nhân viên.",
};

export const dict = { en, ms, zh, id, th, vi };
